const UserProfileKeys = {
    all: ['UserProfiles'] as const,
    specialties: () => [...UserProfileKeys.all, 'specialties'],
    accreditationSpecialties: () => [...UserProfileKeys.all, 'accreditationSpecialties'],
  };

  export { UserProfileKeys };
  